import React, { useEffect, useState } from "react";
import Layout from "../../common/layout";
import { useTranslation } from "react-i18next";
import { MenuGroup, MenuGroupItem, Heading, MenuItem, MenuBox } from "./styels";
import { GetIcon } from "../../../../icons";
import PopupView from "../../../elements/popupview";
import Switch from "../../../router/switch";
import { useDispatch, useSelector } from "react-redux";
import { clearLogin } from "../../../../store/actions/login";
import AutoForm from "../../../elements/form";
import i18n from "i18next"; // i18n library for internationalization
import { getData, postData } from "../../../../backend/api";
import { Title } from "../../common/layout/header/styels";
import { RowContainer } from "../../../styles/containers/styles";
import { useNavigate } from "react-router-dom";
import Checkbox from "../../../elements/checkbox";
import OnOffToggle from "../../../elements/toggle";
const Settings = (props) => {
  const { t } = useTranslation();
  useEffect(() => {
    document.title = `${t("settings")} - PersoBase`;
  }, [t]);
  const [showDetails, setShowDetails] = useState(false);
  const [selectedMenuItem, setSelectedMenuItem] = useState(null);
  const [openData, setOpenData] = useState(null);
  const themeColors = useSelector((state) => state.themeColors);
  const selectedMenu = useSelector((state) => state.selectedMenu);
  const [selectedLanguage, setSelectedLanguage] = useState(
    // If a language is stored in local storage, use it, otherwise use "de"
    localStorage.getItem("_lang") !== null ? localStorage.getItem("_lang") : "de"
  );
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const handleLanguageChange = (language) => {
    // Change the language in the i18n library
    if (selectedLanguage === "en") {
      i18n.changeLanguage("de");
      setSelectedLanguage("de");
      localStorage.setItem("_lang", "de");
    } else {
      i18n.changeLanguage("en");
      setSelectedLanguage("en");
      localStorage.setItem("_lang", "en");
    }
  };
  const [showResetPassword, setShowResetPassword] = useState(false);
  const isCreatingHandler = (value, callback) => {
    setShowResetPassword(false);
  };
  const submitChange = async (post) => {
    //call set password with
    props.setLoaderBox(true);
    await postData({ ...post }, "user/reset-password", dispatch, navigate)
      .then((response) => {
        console.log(response);
        if (response.status === 200) {
          props.setMessage({
            type: 1,
            content: t(response.data.message),
            okay: "Okay",
            onClose: () => {},
            code: 200
          });
          props.setLoaderBox(false);
        } else if (response.status === 201) {
          props.setMessage({ type: 1, content: t(response.data.message), proceed: "Okay", code: 201 });
          props.setLoaderBox(false);
        } else {
          props.setMessage({ type: 1, content: t(response.data.message), proceed: "Okay", code: 500 });
          props.setLoaderBox(false);
        }
        setShowResetPassword(false);
        props.setLoaderBox(false);
      })
      .catch((error) => {
        props.setMessage({ type: 1, content: error.message + "Something went wrong!", proceed: "Okay", code: 500 });
        props.setLoaderBox(false);
      });
  };
  const formInput = [
    {
      type: "password",
      placeholder: "currentPassword",
      name: "currentPassword",
      validation: "",
      default: "",
      label: "currentPassword",
      minimum: 6,
      maximum: 16,
      required: true,
    },
    {
      type: "password",
      placeholder: "newPassword",
      name: "newPassword",
      validation: "passwordMatch",
      default: "",
      label: "newPassword",
      minimum: 6,
      maximum: 16,
      required: true,
    },
    {
      type: "password",
      placeholder: "confirmPassword",
      name: "confirmPassword",
      validation: "passwordMatch",
      default: "",
      label: "confirmPassword",
      minimum: 6,
      maximum: 16,
      required: true,
    },
  ];

  const [toggle, setToggle] = useState(localStorage.getItem("user") !== null ? JSON.parse(localStorage.getItem("user"))?.user?.isAktWhistle : false);

  const handleToggle = async() => {
    try {
      await getData({ }, "whistleblowing/active", dispatch, navigate)
      .then((response) => {
        setToggle(response.data.whistleblowing);
        localStorage.setItem("user", JSON.stringify({ ...JSON.parse(localStorage.getItem("user")), user: { ...JSON.parse(localStorage.getItem("user")).user, isAktWhistle: response.data.whistleblowing } }));
      })
      .catch((error) => {
        console.log(error);
        });
    } catch (error) {
      console.error("Error toggling whistle settings:", error);
      
    }

  }

  return (
    <RowContainer className="list static">
      <Title className="inner">
        <GetIcon icon={"settings"}></GetIcon>
        {t("settings")}
      </Title>
      <MenuGroup>
        {props.router.groups.map((item) => (
          <MenuGroupItem key={item.head}>
            <Heading>{t(item.head)}</Heading>
            <MenuBox>
              {item.menuItems.map((menu) => (
                <MenuItem
                  key={menu.label}
                  onClick={() => {
                    if (menu.label === "logout") {
                      dispatch(clearLogin());
                    } else if (menu.label === "languageSwitch") {
                      handleLanguageChange();
                    } else if (menu.label === "resetPassword") {
                      setShowResetPassword(true);
                    } else if (menu.label === "whistleblowing") {
                      // handleToggle();
                    } else {
                      setOpenData({ data: { name: menu.label } });
                      setSelectedMenuItem(menu);
                      setShowDetails(true);
                    }
                  }}
                >
                  <GetIcon icon={menu.icon}></GetIcon>
                  {t(menu.label)}
                  {menu.checkbox && (
                    <div style={{ marginLeft: "auto" }}>
                      <OnOffToggle on={toggle} handleToggle={handleToggle} page="whistle-settings" />
                    </div>
                  )}
                </MenuItem>
              ))}
            </MenuBox>
          </MenuGroupItem>
        ))}
      </MenuGroup>
      {showDetails && (
        <PopupView
          // Popup data is a JSX element which is binding to the Popup Data Area like HOC
          popupData={selectedMenuItem && <Switch page={selectedMenuItem.element} />}
          themeColors={themeColors}
          closeModal={() => {
            setShowDetails(false);
            setSelectedMenuItem(null);
          }}
          setMessage={props.setMessage}
          setLoaderBox={props.setLoaderBox}
          itemTitle={{ collection: "", name: "name" }}
          openData={openData} // Pass selected item data to the popup for setting the time and taking menu id and other required data from the list item
          customClass={"fullpage nopadding"}
          menu={selectedMenu}
        ></PopupView>
      )}
      {showResetPassword && <AutoForm formMode={"single"} enterSubmit={true} useCaptcha={false} formType={"post"} header={t("resetPassword")} formInput={formInput} submitHandler={submitChange} button={t("confirm")} isOpenHandler={isCreatingHandler} isOpen={true} plainForm={false}></AutoForm>}
    </RowContainer>
  );
};
// exporting the page with parent container layout..
export default Layout(Settings);
